import React, { useContext } from "react";
import { numberToCurrency } from "@components/utils/formatters";
import { DisplayAmount } from "@components/display-amount-context";
import InfoHover from "@components/ui/info-hover";
import SvgInfo from "@components/ui/icons/info";
import * as Styled from "./Styled";

type Props = {
  icon: React.ReactNode;
  label: string;
  value: number;
  info?: string | React.ReactNode;
};

export const CurrencyBoardValue: React.FC<Props> = ({
  icon,
  label,
  value,
  info,
}) => {
  const {
    state: { displayAmount },
  } = useContext(DisplayAmount);

  return (
    <Styled.BoardValue>
      <span>
        <i>{icon}</i>
        {label}
      </span>

      <p>
        {displayAmount ? numberToCurrency(value) : "••••"}

        {info && (
          <InfoHover
            icon={<SvgInfo color="#1D297C" width="20" />}
            content={info}
          />
        )}
      </p>
    </Styled.BoardValue>
  );
};
